const INITIAL_STATE = {
    open: false,
    callback: undefined,
    type: undefined
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case 'DRAWER_PDF_OPEN':
            return { open: true, callback: action.payload };

        case 'DRAWER_PDF_CLOSE':
            return { open: false };

        case 'DRAWER_PDF_TYPE':
            return { open: false, type: action.payload };
                   
        default:
            return state;
    }
}
